import React from 'react';
import SectionTitle from '../../components/SectionTitles/SectionTitle';
// import HomeCardData from '../../data/work/BussinessCardData copy.json';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.css';
import YantCards from '../../data/brand/BizCards.json';
import SwiperCore ,{EffectFade,Navigation} from 'swiper';
import "swiper/components/navigation/navigation.min.css";
import './BizStyles.css'


const BussinessCards = () => {
    SwiperCore.use([EffectFade,Navigation]);

    return (
        <div className="section section-paddingTopBottom mt-5" style={{padding:'25px 0px 50px 0px'}}>
            <div className="container" >

                <SectionTitle
                    headingOption="title fz-32"
                    title="Efficiency For Every Business"
                />

                    <div className="row  content-paddingTop" style={{paddingBottom:'20px'}} > 
                    <div className="col mb-6" data-aos="fade-up" data-aos-delay="300" >
                        {/* <div className="about-content-area" >
                        <div className="brand-wrapper">
                            <div className="brand-list" > */}
                            <Swiper 
                                
                                slidesPerView={4}
                                spaceBetween={-39}
                                navigation={true}
                                // effect="fade"
                                // pagination={{clickable:true, marginTop:'100px'}}
                                
                                grabCursor={true}
                                // speed={500}
                                loop    
                                // pagination={{
                                //     el: '.my-custom-pagination-div',
                                //     clickable: true,
                                //     renderBullet: (index, className) => {
                                //      return '<span class="' + className + '">' + (index + 1) + "</span>";
                                //     },
                                //   }}    
                                className="mySwiper"
                                // autoplay ={{delay:100}}
                                // autoplay={{delay:300}}
                                // controller={true}
                                // speed ={500}
                                // style={{overflow:'visible'}}
                                    
                                // loop
                                breakpoints= {{
                                    1200:{
                                        slidesPerView :3 
                                    },

                                    992:{
                                        slidesPerView : 3
                                    },

                                    768:{
                                        slidesPerView : 2

                                    },

                                    576:{
                                        slidesPerView : 1
                                    },

                                 
                                    320:{
                                        slidesPerView : 1
                                    }

                                }}
                                >

                    
                                {YantCards && YantCards.map((single, key) => {
                                    return(
                                        
                                                <SwiperSlide key={key} >
                                                    <div className="row" style={{margin:'0px 50px'}}>
                                                    <div className="col">
                                                        <div className="card overlay-two efeb-img b" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/${single.image})`,objectFit:'cover', height:'27rem',border:'aliceblue'}}>
                                                        <div className="card-body">
                                                            <h5 className="card-title title" style={{textAlign:'center', color:'#fff'}}><strong>{single.title}</strong></h5>
                                                            <p className="card-text" id ="BizDesc" style={{padding:'80px 10px 5px' ,textAlign:'center', color:'#EEEEEE'}}>{single.desc}</p>
                                                        </div>
                                                        </div>
                                                    </div>

                                                        </div>

                                                </SwiperSlide>
                        )
                                        })}
{/*                                           
                                                <SwiperSlide style={{margin:'0px 0px'}} >
                                                <div className="card" style={{width: "15rem",backgroundColor:'#030e22',border:'none',textAlign:'left',borderRadius:'10px'}}>
                                                    <img src="images/computer.png" className="card-img-top" alt="..." style={{ maxWidth:'200px',margin:'15px auto 0px auto'}}/>
                                                    <div className="card-body">
                                                       
                                                    </div>
                                                  
                                                    <div className="card-body hoverCard" style={{minHeight:'200px',padding:'20px 30px'}}>
                                                        <h4 style={{ marginBottom:'10px',
                                                            fontWeight: '900',
                                                            fontSize: 'clamp(1.5rem * 0.8, 2vw, 0.5rem)',
                                                            lineHeight: '1.35',
                                                            color: '#2ea3f2 '}}>Medical Offices</h4>
                                                            <p className="desc" style={{color:'#fff'}}>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Et odit libero </p>
                                                    </div>
                                                    </div>     

                                                </SwiperSlide>

                                                <SwiperSlide style={{margin:'0px 0px'}}>
                                                <div className="card" style={{width: "15rem",backgroundColor:'#030e22',border:'none',textAlign:'left',borderRadius:'10px'}}>
                                                    <img src="images/computer.png" className="card-img-top" alt="..." style={{ maxWidth:'200px',margin:'15px auto 0px auto'}}/>
                                                    <div className="card-body">
                                                       
                                                    </div>
                                                  
                                                    <div className="card-body hoverCard" style={{minHeight:'200px',padding:'20px 30px'}}>
                                                        <h4 style={{ marginBottom:'10px',
                                                            fontWeight: '900',
                                                            fontSize: 'clamp(1.5rem * 0.8, 2vw, 0.5rem)',
                                                            lineHeight: '1.35',
                                                            color: '#2ea3f2 '}}>Physical Theraphy Clinics</h4>
                                                            <p className="desc" style={{color:'#fff'}}>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Et odit libero </p>
                                                    </div>
                                                    </div>     

                                                </SwiperSlide>   */}
      
                                </Swiper>
                            </div>
</div>







                {/* <div className="row  content-paddingTop" style={{paddingBottom:'20px'}} >

                    {HomeCardData && HomeCardData.map((single, key) => {
                            return(
                                <div key={key} className="col mb-6" data-aos="fade-up" data-aos-delay="300" >
                                    <div className="row">
                                        <div className="col">
                                            <div className="card bgBCard overlay-two">
                                            <div className="card-body">
                                                <h5 className="card-title" style={{textAlign:'center', color:'white'}}>{single.Ptitle}</h5>
                                                <p className="card-text" style={{padding:'40px 10px' ,textAlign:'center', color:'#fff'}}>{single.desc}</p>
                                            </div>
                                            </div>
                                        </div>

                                        </div>
                    
                                </div>
                            ); 
                    })}
                    
                </div> */}

            </div>
        </div>
    )
}

export default BussinessCards;
